import React from 'react'
import { FieldObject } from './types'

export const isAJSXElement = (item: FieldObject | JSX.Element) =>
  typeof item === 'object' && React.isValidElement(item)
